module.exports = __webpack_public_path__ + "static/img/花瓶4.c19051b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/papercutLamp/imgs/花瓶4.png
// module id = /oSs
// module chunks = 2